import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as setupStatusState from '../reducers';
import * as setupStatusReducer from '../reducers/setup-status.reducer';

export const selectSetupStatus = createSelector(
  setupStatusState.GetSetupStatusState,
  setupStatusReducer.getIsSetupStatus
);
